import { render, staticRenderFns } from "./Vehicle.vue?vue&type=template&id=71bd6d4e&"
import script from "./Vehicle.vue?vue&type=script&lang=ts&"
export * from "./Vehicle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports